import React from 'react'
import { useNavigate } from 'react-router-dom'

import { DcButton, PixelModal, PixelTable } from 'pixel-base'
import styled from 'styled-components'
import { get, getBankAccounts } from 'utils/api-routes.util'
import CheckIcon from 'utils/icons/check-icon'
import PlusIcon from 'utils/icons/plus-icon'
import XmarkIcon from 'utils/icons/xmark-icon'

import AddUpdateBankAccount from './components/AddUpdateBankAccount'
import FinancePageShell from '../../components/FinancePageShell'

const BankAccounts = () => {
  const navigate = useNavigate()

  const columns = [
    {
      dataField: 'bank_name',
      width: '15%',
      name: <TableHeadings>Bank Name</TableHeadings>,
      selector: (row) => row.bank_name || '--',
    },
    {
      dataField: 'account_title',
      width: '15%',
      name: <TableHeadings>Account Title</TableHeadings>,
      selector: (row) => row.account_title || '--',
    },
    {
      dataField: 'account_number',
      name: <TableHeadings>Account Number</TableHeadings>,
      selector: (row) => row.account_number || '--',
    },
    {
      dataField: 'account_type',
      name: <TableHeadings>Account Type</TableHeadings>,
      selector: (row) => row.account_type || '--',
    },
    {
      dataField: 'bank_short_name',
      name: <TableHeadings>Account Short Name</TableHeadings>,
      selector: (row) => row.bank_short_name || '--',
    },

    {
      dataField: 'is_active',
      name: <TableHeadings>Is Active?</TableHeadings>,
      selector: (row) =>
        row.is_active ? <CheckIcon color="green" /> : <XmarkIcon color="red" />,
    },
  ]
  const [countries, setCountries] = React.useState({
    list: [],
    default: '',
  })
  const getAllCountries = () => {
    get('/settings/options/countries').subscribe((res: any) => {
      setCountries({
        list: res.response.data,
        default: res.response._meta?.default,
      })
    })
  }
  React.useEffect(() => {
    getAllCountries()
  }, [])
  const [bankAccounts, setBankAccounts] = React.useState<any>([])
  const [tableLoading, setTableLoading] = React.useState(false)
  const [newAccountModal, setNewAccountModal] = React.useState(false)

  const getAllBankAccounts = () => {
    setTableLoading(true)
    getBankAccounts().subscribe((res) => {
      setBankAccounts(res.response.data)
      setTableLoading(false)
    })
  }

  React.useEffect(() => {
    getAllBankAccounts()
  }, [])
  const onRowClicked = (row) =>
    navigate(`/finance/settings/bank-accounts/${row.bank_id}`)

  return (
    <>
      <FinancePageShell
        title="Bank Accounts"
        isLoading={tableLoading}
        primaryAction={{
          label: 'Add Bank Account',
          onClick: () => setNewAccountModal(true),
        }}
      >
        <PixelTable
          columns={columns}
          data={bankAccounts || []}
          progressPending={tableLoading}
          highlightOnHover={true}
          pointerOnHover={true}
          onRowClicked={onRowClicked}
        />
      </FinancePageShell>

      {newAccountModal && (
        <PixelModal
          size={'lg'}
          title={'Add Bank Account'}
          handleClose={() => setNewAccountModal(false)}
          show={newAccountModal}
        >
          <AddUpdateBankAccount
            handleClose={() => setNewAccountModal(false)}
            countries={countries}
          />
        </PixelModal>
      )}
    </>
  )
}

const TableHeadings = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  max-width: 100%;
  width: 100%;
`

export default BankAccounts
